import React, { Component, Fragment } from "react";
import {
  Button,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Card,
  CardBody,
  CardFooter,
  CardHeader
} from "reactstrap";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import { reduxForm, Field } from 'redux-form'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import NumberFormat from 'react-number-format';
import * as contractAction from './actions'
import * as contractConstant from './constants'
import Autocomplete from "../controls/_Autocomplete";
import Messages from '../../notifications/Messages'
import Errors from '../../notifications/Errors'
import { formatDateTime } from '../../lib/common';

class EditContract extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    contractsDetailRequest: PropTypes.func,
    contractsUpdateRequest: PropTypes.func,
    contractsNhanVienRequest: PropTypes.func,
    contractsLoaiRequest: PropTypes.func,
    contractsTrangThaiRequest: PropTypes.func,
    contractsKhachHangRequest: PropTypes.func,
    editContract: PropTypes.shape({
      list: PropTypes.array,
      listLoaiHD: PropTypes.array,
      listTrangThaiHD: PropTypes.array,
      listNhanVien: PropTypes.array,
      listKhachHang: PropTypes.array,
      item: PropTypes.object,
      type: PropTypes.string,
      listRequesting: PropTypes.bool,
      requesting: PropTypes.bool,
      successful: PropTypes.bool,
      messages: PropTypes.array,
      errors: PropTypes.array,
    }),
  }
  constructor(props) {
    super(props);
    this.state = {
      item: {
        SoHopDong: 0,
        TenHopDong: "",
        NgayKy: moment().format("YYYY-MM-DD"),
        TuNgay: moment().format("YYYY-MM-DD"),
        DenNgay: moment().format("YYYY-MM-DD"),
        KhachHangId: 0,
        TenKhachHang: "",
        DienThoai: "",
        StoreId: 0,
        LoaiId: 0,
        TrangThaiId: 0,
        NhanVienId: 0,
        TenNhanVien: "",
        ChietKhau: 0,
        TongGiaTri: 0,
        GhiChu: ""
      },
      selectedKhachHangOption: null,
      formError: {}
    };
    this.handleDateChange = this.handleDateChange.bind(this);
  }
  getParam = (name) => {
    const queryParamsString = this.props.location.search.substring(1), // remove the "?" at the start
      searchParams = new URLSearchParams(queryParamsString);
    return searchParams.get(name);
  }
  handleNumberChange = (name, e) => {
    let { item } = this.state
    const floatValue = e.floatValue;
    if (floatValue > 0) {
      item[name] = floatValue
      this.setState({ item })
    }
  }
  handleDateChange(name, e) {
    let { item } = this.state;
    switch (name) {
      case "TuNgay":
        item.TuNgay = e.format("YYYY-MM-DD");
        break;
      case "DenNgay":
        item.DenNgay = e.format("YYYY-MM-DD");
        break;
      case "NgayKy":
        item.NgayKy = e.format("YYYY-MM-DD");
        break;
    }
    this.setState({ item })
  }
  handleControlChange = (e) => {
    let { item } = this.state
    item[e.target.name] = e.target.value
    this.setState({ item })
  }
  handleSelectChange = (name, selectedOption) => {
    let { item } = this.state;
    switch (name) {
      case "TrangThai":
        item.TrangThaiId = selectedOption.target.value
        break;
      case "Loai":
        item.LoaiId = selectedOption.target.value
        break;
      case "NhanVien":
        item.NhanVienId = selectedOption.target.value
        var index = selectedOption.target.selectedIndex;
        item.TenNhanVien = selectedOption.target[index].text
        break;
      default:
        break;
    }
    this.setState({ item })
  }
  featchDetail = () => {
    const { contractsDetailRequest } = this.props
    let hopdong_id = this.getParam("contract");
    var requestData = {
      hopdong_id: hopdong_id
    }
    return contractsDetailRequest(requestData);
  }
  featchLoaiHopDong = () => {
    const { contractsLoaiRequest } = this.props;
    return contractsLoaiRequest();
  }
  featchTrangThaiHopDong = () => {
    const { contractsTrangThaiRequest } = this.props;
    return contractsTrangThaiRequest();
  }
  featchNhanVien = () => {
    const { contractsNhanVienRequest } = this.props;
    return contractsNhanVienRequest();
  }
  featchKhachHang = (keyword, callback) => {
    const { contractsKhachHangRequest } = this.props;
    var formRequest = {
      page: 1,
      per_page: 20,
      keyword: keyword
    }
    return contractsKhachHangRequest(formRequest, callback);
  }
  numberOnclick = (e) => {
    e.currentTarget.setSelectionRange(0, e.currentTarget.value.length)
  }

  UpdateContracts = () => {
    let {item} = this.state
    this.props.contractsUpdateRequest(item);
  }
  formatOptionLabel = (option) => {
    return (
      <div>
        {option.label}<span className={"item_unit"}> ({option.email} - {option.dienthoai})</span>
      </div>
    )
  }
  formatNoOptionLabel = (option) => {
    return (
      <Fragment>
        <em>Không tìm thấy danh mục <i className="text-danger">{option}</i></em>
      </Fragment>
    )
  }
  numberOnclick = (e) => {
    e.currentTarget.setSelectionRange(0, e.currentTarget.value.length)
  }
  onHandleSelectChange = (selectedKhachHangOption, e) => {
    let { item } = this.state;
    item.TenKhachHang = selectedKhachHangOption.label
    item.DienThoai = selectedKhachHangOption.dienthoai
    item.StoreId = selectedKhachHangOption.storeid
    item.KhachHangId = selectedKhachHangOption.storeid
    this.setState({ selectedKhachHangOption, item: item })
  }

  khachHangChanged = (input, callback) => {
    this.featchKhachHang(input, callback);
  }

  componentDidMount() {
    this.featchLoaiHopDong();
    this.featchTrangThaiHopDong();
    this.featchNhanVien();
    this.featchDetail();
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.editContract.type == contractConstant.CONTRACTS_DETAIL_SUCCESS) {
      let { item } = nextProps.editContract;
      if(item.HopDongId && item.HopDongId > 0){
        item.NgayKy = moment(item.NgayKy).format("YYYY-MM-DD")
        item.TuNgay = moment(item.TuNgay).format("YYYY-MM-DD")
        item.DenNgay = moment(item.DenNgay).format("YYYY-MM-DD")
        this.setState({
          item: item
        });
        this.khachHangSelect.setValueBox(item.TenKhachHang);
      }
    }else if (nextProps.editContract.type == contractConstant.CONTRACTS_UPDATE_SUCCESS) {
      this.props.history.push("/hop-dong");
    }
  }
  render() {
    const { formError, item } = this.state;
    const {
      handleSubmit,
      editContract: {
        listLoaiHD,
        listTrangThaiHD,
        listNhanVien,
        listKhachHang,
        isRequesting,
        errors,
        messages
      },
    } = this.props

    const suggestions = (listKhachHang || []).map(item => {
      return { value: item.StoreId, label: item.Ten, dienthoai: item.DienThoai, email: item.Email, storeid: item.StoreId };
    });

    return (
      <div className="animated fadeIn">
        <BlockUi tag="div">
          <Row>
            <div className="col-sm-4">
              <Card>
                <CardHeader>
                  <i className="fa fa-align-justify"></i> Thông tin khách hàng
            </CardHeader>
                <CardBody className="card-body">
                  <Row>
                    <Col sm="12">
                      <FormGroup>
                        <Label htmlFor="ten">Điện thoại, Email, Tên khách hàng</Label><span className="text-red"> (*)</span>
                        <Autocomplete
                          name="khachHangSelect"
                          placeholder="Thông tin khách hàng"
                          formatOptionLabel={this.formatOptionLabel}
                          formatNoOptionLabel={this.formatNoOptionLabel}
                          handleChange={this.khachHangChanged.bind(this)}
                          onSelection={this.onHandleSelectChange.bind(this)}
                          suggestions={suggestions}
                          onRef={ref => (this.khachHangSelect = ref)}
                          clearOnSelection={false}
                        />
                        <em className="error invalid-feedback">{formError.Ten}</em>
                      </FormGroup>
                    </Col>
                    <Col sm="12">
                      <FormGroup>
                        <Label htmlFor="TenKhachHang">Tên khách hàng</Label><span className="text-red"> (*)</span>
                        <Input type="text" className="form-control" name="TenKhachHang" value={item.TenKhachHang || ''} onChange={this.handleControlChange.bind(this)} />
                      </FormGroup>
                    </Col>
                    <Col sm="12">
                      <FormGroup>
                        <Label htmlFor="DienThoai">Điện thoại</Label><span className="text-red"> (*)</span>
                        <Input type="text" className="form-control" name="DienThoai" value={item.DienThoai || ''} onChange={this.handleControlChange.bind(this)} />
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </div>
            <div className="col-sm-8">
              <Card>
                <CardHeader>
                  <i className="fa fa-align-justify"></i> Thông tin hợp đồng
            </CardHeader>
                <CardBody className="card-body">
                  <Row>
                    <Col sm="3">
                      <FormGroup>
                        <Label htmlFor="SoHopDong">Số hợp đồng</Label>
                        <Input type="text" className="form-control" name="SoHopDong" value={item.SoHopDong || ''}
                          onChange={this.handleControlChange.bind(this)}
                        />
                      </FormGroup>
                    </Col>
                    <Col sm="3">
                      <FormGroup>
                        <Label htmlFor="TenHopDong">Tên hợp đồng</Label>
                        <Input type="text" className="form-control" name="TenHopDong" value={item.TenHopDong || ''}
                          onChange={this.handleControlChange.bind(this)}
                        />
                      </FormGroup>
                    </Col>
                    <Col sm="3">
                      <FormGroup>
                        <Label htmlFor="NgayKy">Ngày hợp đồng</Label><span className="text-red"> (*)</span>
                        <div>
                          <DatePicker name="NgayKy"
                            onChange={this.handleDateChange.bind(this, "NgayKy")} selected={new moment(item.NgayKy)}
                            required className={"form-control"} autoComplete="off" dateFormat="DD/MM/YYYY" />
                        </div>

                      </FormGroup>
                    </Col>
                    <Col sm="3">
                      <FormGroup>
                        <Label htmlFor="TuNgay">Ngày hiệu lực</Label><span className="text-red"> (*)</span>
                        <div>
                          <DatePicker name="TuNgay"
                            onChange={this.handleDateChange.bind(this, "TuNgay")} selected={new moment(item.TuNgay)}
                            required className={"form-control"} autoComplete="off" dateFormat="DD/MM/YYYY" />
                        </div>
                      </FormGroup>
                    </Col>
                    <Col sm="3">
                      <FormGroup>
                        <Label htmlFor="DenNgay">Ngày hết hạn</Label><span className="text-red"> (*)</span>
                        <div>
                          <DatePicker name="DenNgay"
                            onChange={this.handleDateChange.bind(this, "DenNgay")} selected={new moment(item.DenNgay)}
                            required className={"form-control"} autoComplete="off" dateFormat="DD/MM/YYYY" />
                        </div>
                      </FormGroup>
                    </Col>
                    <Col sm="3">
                      <FormGroup>
                        <Label htmlFor="Loai">Loại hợp đồng</Label>
                        <select name="LoaiThuChi" className={"form-control"} onChange={this.handleSelectChange.bind(this, "Loai")}
                          value={this.state.item.LoaiId}>
                          <option value={0} key={0}>--Loại hợp đồng--</option>
                          {listLoaiHD.map(option => {
                            return (
                              <option value={option.id} key={option.id}> {option.Ten}</option>
                            )
                          })
                          }
                        </select>
                      </FormGroup>
                    </Col>
                    <Col sm="3">
                      <FormGroup>
                        <Label htmlFor="TrangThai">Trạng thái hợp đồng</Label>
                        <select name="LoaiThuChi" className={"form-control"} onChange={this.handleSelectChange.bind(this, "TrangThai")}
                          value={this.state.item.TrangThaiId}>
                          <option value={0} key={0}>--Trạng thái hợp đồng--</option>
                          {listTrangThaiHD.map(option => {
                            return (
                              <option value={option.id} key={option.id}> {option.Ten}</option>
                            )
                          })
                          }
                        </select>
                      </FormGroup>
                    </Col>
                    <Col sm="3">
                      <FormGroup>
                        <Label htmlFor="TongGiaTri">Tổng giá trị</Label>
                        <NumberFormat
                          name={"TongGiaTri"}
                          value={item.TongGiaTri}
                          defaultValue={1}
                          thousandSeparator={"."}
                          decimalSeparator={","}
                          type="tel"
                          maxLength={12}
                          onClick={this.numberOnclick.bind(this)}
                          onValueChange={this.handleNumberChange.bind(this, "TongGiaTri")}
                          className={"form-control order-input-sl price"} />
                      </FormGroup>
                    </Col>
                    <Col sm="3">
                      <FormGroup>
                        <Label htmlFor="ChietKhau">Chiết khấu</Label>
                        <NumberFormat
                          name={"ChietKhau"}
                          value={item.ChietKhau}
                          defaultValue={0}
                          thousandSeparator={"."}
                          decimalSeparator={","}
                          type="tel"
                          maxLength={10}
                          onClick={this.numberOnclick.bind(this)}
                          onValueChange={this.handleNumberChange.bind(this, "ChietKhau")}
                          className={"form-control order-input-sl price"} />
                      </FormGroup>
                    </Col>
                    <Col sm="4">
                      <FormGroup>
                        <Label htmlFor="nhanvien">Nhân viên kinh doanh</Label>
                        <select name="LoaiThuChi" className={"form-control"} onChange={this.handleSelectChange.bind(this, "NhanVien")}
                          value={this.state.item.NhanVienId}>
                          <option value={0} key={0}>--Nhân viên--</option>
                          {listNhanVien.map(option => {
                            return (
                              <option value={option.id} key={option.id}> {option.Ten}</option>
                            )
                          })
                          }
                        </select>
                      </FormGroup>
                    </Col>
                    <Col sm="12">
                      <FormGroup>
                        <Label htmlFor="UrlImg">Đường dẫn ảnh</Label>
                        <Input type="text" className="form-control" name="UrlImg" value={item.UrlImg || ''}
                          onChange={this.handleControlChange.bind(this)} />
                      </FormGroup>
                    </Col>
                    <Col sm="12">
                      <FormGroup>
                        <Label htmlFor="ghichu">Ghi chú</Label>
                        <textarea className="form-control" value={item.GhiChu || ''} name="GhiChu" onChange={this.handleControlChange.bind(this)}></textarea>
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter>
                  <div className="text-right">
                    <Button color="primary" onClick={handleSubmit(this.UpdateContracts)}><i className="fa fa-save"></i>&nbsp;Lưu</Button>&nbsp;&nbsp;
                    <Button color="secondary"><i className="fa fa-close"></i>&nbsp;Hủy</Button>
                  </div>
                </CardFooter>
              </Card>
            </div>
          </Row>
        </BlockUi>
        <Row>
          <Col md="12">
            {!isRequesting && !!errors.length && (
              <Errors errors={errors} />
            )}
            {!isRequesting && !!messages.length && (
              <Messages messages={messages} />
            )}
          </Col>
        </Row>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  editContract: state.editContract,
})

const connected = connect(mapStateToProps, {
  contractsDetailRequest: contractAction.contractsDetailRequest,
  contractsUpdateRequest: contractAction.contractsUpdateRequest,
  contractsNhanVienRequest: contractAction.contractsNhanVienRequest,
  contractsLoaiRequest: contractAction.contractsLoaiRequest,
  contractsTrangThaiRequest: contractAction.contractsTrangThaiRequest,
  contractsKhachHangRequest: contractAction.contractsKhachHangRequest
})(EditContract)

const formed = reduxForm({
  form: 'editContract',
})(connected)

export default formed;



// WEBPACK FOOTER //
// ./src/views/Contracts/EditContract.js